import { Divider as MuiDivider } from "@mui/material";

type DividerColor = "neutral-softer" | "neutral-soft";

const COLOR_MAP: Record<DividerColor, string> = {
  "neutral-softer": "var(--color-stroke-neutral-softer)",
  "neutral-soft": "var(--color-stroke-neutral-soft)",
};

type Props = {
  orientation?: "vertical" | "horizontal";
  color?: DividerColor;
};

export const Divider = ({ orientation = "horizontal", color }: Props) => {
  return (
    <MuiDivider
      orientation={orientation}
      sx={color ? { borderColor: COLOR_MAP[color] } : undefined}
    />
  );
};
